
const WhatsAppIcon = ({ size = 30 }: { size?: number }) => (
  <img 
    src="/lovable-uploads/e38b2cb7-e367-421a-b3be-c852faea8a97.png" 
    width={size} 
    height={size} 
    alt="WhatsApp" 
  />
);

export default WhatsAppIcon;
